import classNames from "classnames";
import { BadgeColor, badgeColorSchemes } from "./badgeColorScheme";

// maybe we outline and modern is another prop/"type"
// I think this is simpler to avoid nested if statements for styling and just match 1-to-1 with the mock
export const badgeTypes = [
  "badge",
  "badge-outline",
  "badge-modern",
  "pill",
  "pill-outline",
] as const;
export type BadgeType = (typeof badgeTypes)[number];

type Props = {
  text: string;
  badgeType?: BadgeType;
  badgeColor?: BadgeColor;
  leftIcon?: JSX.Element;
  rightIcon?: JSX.Element;
};

export const BadgeNew = ({
  text,
  badgeType = "badge",
  badgeColor = "gray",
  leftIcon,
  rightIcon,
}: Props) => {
  const colorScheme = badgeColorSchemes[badgeColor];

  const iconClassName = classNames("rounded-3xl", colorScheme.iconColor);

  return (
    <span
      className={classNames(
        "inline-flex items-center px-2 py-[2px] border text-sm gap-[6px]",
        badgeType !== "badge-modern"
          ? classNames(colorScheme.background, colorScheme.border)
          : "",
        {
          "rounded-md": badgeType === "badge",
          "bg-white rounded-md": badgeType === "badge-outline",
          "rounded-full": badgeType === "pill",
          "bg-white rounded-full": badgeType === "pill-outline",
          "bg-primary border-primary rounded-md": badgeType === "badge-modern",
        }
      )}
    >
      {leftIcon && <span className={iconClassName}>{leftIcon}</span>}
      <span
        className={classNames(
          "whitespace-nowrap text-center",
          badgeType === "badge-modern" ? "text-secondary" : colorScheme.color
        )}
      >
        {text}
      </span>
      {rightIcon && <div className={iconClassName}>{rightIcon}</div>}
    </span>
  );
};
